import script from "./DefaultCounterCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultCounterCard.vue?vue&type=script&setup=true&lang=js"

import "./DefaultCounterCard.vue?vue&type=style&index=0&id=501d546d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-501d546d"]])

export default __exports__